import React from 'react';
import { Box, Grid, Stack, Typography } from '@mui/material';
import Section from '../shared/Section';
import SectionHeading from '../shared/SectionHeading';

const impactDescription =
  'Partnering with FoodFe activates tech-enabled programmes that redirect surplus, upskill chefs, and bring communities together around low-waste meals.';

export const Together = () => {
  const togetherImage = `${process.env.PUBLIC_URL}/assets/food_image3.png`;
  return (
    <Section background='#FFFFFF'>
      <Grid container spacing={{ xs: 6, md: 10 }} alignItems='center'>
        <Grid item xs={12} md={6}>
          <Stack spacing={4}>
            <SectionHeading
              align='left'
              eyebrow='Impact'
              title='Together, let us turn every surplus into shared value'
              description={impactDescription}
            />
            <Typography variant='body1'>
              Beyond daily operations, our platform coordinates recovery events, chef training, and donation drop-offs so extra portions fuel local impact instead of landfill. Every order helps us scale a smarter, kinder food system.
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              position: 'relative',
              width: { xs: '92%', md: '85%' },
              maxWidth: 480,
              mx: 'auto',
              borderRadius: 36,
              overflow: 'hidden',
              p: { xs: 2, md: 2.5 },
              background: 'linear-gradient(140deg, rgba(246,120,95,0.18) 0%, rgba(255,255,255,0.92) 100%)',
              boxShadow: '0px 30px 64px rgba(31, 36, 51, 0.18)',
            }}
          >
            <Box
              component='img'
              src={togetherImage}
              alt='People sharing a meal'
              sx={{
                width: '100%',
                height: { xs: 260, sm: 320, md: 360 },
                objectFit: 'cover',
                display: 'block',
                borderRadius: 28,
                boxShadow: '0px 18px 32px rgba(31, 36, 51, 0.14)',
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                inset: 0,
                borderRadius: 'inherit',
                border: '1px solid rgba(255, 255, 255, 0.3)',
                pointerEvents: 'none',
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Section>
  );
};
